import { AxiosClient } from "./AxiosClient";

export const getGraphEdges = (limit) => {
  try {
    const params = limit ? `?limit=${limit}` : "";
    return AxiosClient.get("graph/getConnectedNodeEdges" + params);
  } catch (e) {
    console.log(e);
  }
};

export const getAllConnectedNodeEdgesTypes = () => {
  try {
    return AxiosClient.get("graph/getAllConnectedNodeEdgeTypes", {
      useTarget: true,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getConnectedNodeByName = (nodeName, limit) => {
  try {
    let url = "graph/getConnectedNodeByName?node_name=" + nodeName;
    if (limit) url += "&limit=" + limit;
    return AxiosClient.get(url, { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const getConnectedNodeByType = (nodeType, limit) => {
  try {
    let url = "graph/getConnectedNodeByType?node_type=" + nodeType;
    if (limit) url += "&limit=" + limit;
    return AxiosClient.get(url, { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const getConnectedEdgeByType = (edgeType, limit) => {
  try {
    let url = "graph/getConnectedEdgeByType?edge_type=" + edgeType;
    if (limit) url += "&limit=" + limit;
    return AxiosClient.get(url, { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const getConnectedEdgeByName = (edgeName, limit) => {
  try {
    let url = "graph/getConnectedEdgeByName?edge_name=" + edgeName;
    if (limit) url += "&limit=" + limit;
    return AxiosClient.get(url, { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const createNode = (payload) => {
  try {
    return AxiosClient.post("graph/createNode", payload);
  } catch (e) {
    console.log(e);
  }
};

export const createEdge = (payload) => {
  try {
    return AxiosClient.post("graph/createEdge", payload);
  } catch (e) {
    console.log(e);
  }
};

export const deleteNode = (payload) => {
  try {
    return AxiosClient.delete("graph/deleteNode", { data: payload });
  } catch (e) {
    console.log(e);
  }
};

export const deleteEdge = (payload) => {
  try {
    return AxiosClient.delete("graph/deleteEdge", { data: payload });
  } catch (e) {
    console.log(e);
  }
};

export const updateNode = (payload) => {
  try {
    return AxiosClient.put("graph/updateNode", payload);
  } catch (e) {
    console.log(e);
  }
};

export const updateEdge = (payload) => {
  try {
    return AxiosClient.put("graph/updateEdge", payload);
  } catch (e) {
    console.log(e);
  }
};

export const getTeamGraphs = () => {
  try {
    return AxiosClient.get("graph/getTeamGraphs");
  } catch (e) {
    console.log(e);
  }
};

export const getTeamMemberGraph = (userUuid, limit) => {
  try {
    let url = "graph/getTeamMemberGraph?user_uuid=" + userUuid;
    if (limit) url += "&limit=" + limit;
    return AxiosClient.get(url);
  } catch (e) {
    console.log(e);
  }
};

export const searchGraph = (query, limit, scope, userUuid, scopeValue) => {
  try {
    let url = "graph/searchGraph?q=" + encodeURIComponent(query);
    if (limit) url += "&limit=" + limit;
    if (scope) url += "&scope=" + scope;
    if (userUuid) url += "&user_uuid=" + userUuid;
    if (scopeValue) url += "&scope_value=" + encodeURIComponent(scopeValue);
    return AxiosClient.get(url);
  } catch (e) {
    console.log(e);
  }
};

export const getGlobalGraph = (limit) => {
  try {
    const params = limit ? `?limit=${limit}` : "";
    return AxiosClient.get("graph/getGlobalGraph" + params);
  } catch (e) {
    console.log(e);
  }
};

export const getGraphCounts = (scope, userUuid, scopeValue, filters) => {
  try {
    if (scope === "custom_view" && filters) {
      return AxiosClient.post("graph/getGraphCounts", {
        scope,
        user_uuid: userUuid || "",
        filters,
      });
    }
    let url = "graph/getGraphCounts";
    const params = [];
    if (scope) params.push("scope=" + encodeURIComponent(scope));
    if (userUuid) params.push("user_uuid=" + encodeURIComponent(userUuid));
    if (scopeValue)
      params.push("scope_value=" + encodeURIComponent(scopeValue));
    if (params.length) url += "?" + params.join("&");
    return AxiosClient.get(url);
  } catch (e) {
    console.log(e);
  }
};

// ── Graph Views & Favorites ──────────────────────────────────────────────

export const getGraphViews = () => {
  try {
    return AxiosClient.get("graph/getGraphViews");
  } catch (e) {
    console.log(e);
  }
};

export const getGraphSources = () => {
  try {
    return AxiosClient.get("graph/getGraphSources");
  } catch (e) {
    console.log(e);
  }
};

export const getFilteredGraphView = (payload) => {
  try {
    return AxiosClient.post("graph/getFilteredGraphView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const getFilteredGraphViewStats = (payload) => {
  try {
    return AxiosClient.post("graph/getFilteredGraphViewStats", payload);
  } catch (e) {
    console.log(e);
  }
};

export const createGraphView = (payload) => {
  try {
    return AxiosClient.post("graph/createGraphView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const updateGraphView = (payload) => {
  try {
    return AxiosClient.put("graph/updateGraphView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const deleteGraphView = (payload) => {
  try {
    return AxiosClient.delete("graph/deleteGraphView", { data: payload });
  } catch (e) {
    console.log(e);
  }
};

export const favoriteGraphView = (payload) => {
  try {
    return AxiosClient.post("graph/favoriteGraphView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const unfavoriteGraphView = (payload) => {
  try {
    return AxiosClient.delete("graph/unfavoriteGraphView", { data: payload });
  } catch (e) {
    console.log(e);
  }
};

export const saveGraphViewOrder = (payload) => {
  try {
    return AxiosClient.post("graph/saveGraphViewOrder", payload);
  } catch (e) {
    console.log(e);
  }
};

export const deleteGraphNodes = ({ document_ids }) => {
  try {
    return AxiosClient.post("graph/deletePosts", {
      confirm: true,
      document_ids,
    });
  } catch (e) {
    console.log(e);
  }
};

export const exportGraphJSON = ({ document_ids }) => {
  try {
    return AxiosClient.post("graph/exportPosts", {
      include_content: true,
      include_screenshots: true,
      document_ids,
    });
  } catch (e) {
    console.log(e);
  }
};
